export const getRequestHeaders = () => {
  const requestHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  return requestHeaders;
};
